import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { queryClient } from '@/services/query-client';

interface User {
	id: string;
	email: string;
	name: string;
	role: string;
}

interface AuthState {
	user: User | null;
	token: string | null;
	isAuthenticated: boolean;
	login: (user: User, token: string) => void;
	logout: () => void;
}

export const useAuthStore = create<AuthState>()(
	persist(
		(set) => ({
			user: null,
			token: null,
			isAuthenticated: false,
			// Clear all cached queries on every session change so data from the
			// previous session (real or mock test-user) never leaks into the next.
			login: (user, token) => {
				queryClient.clear();
				set({ user, token, isAuthenticated: true });
			},
			logout: () => {
				set({ user: null, token: null, isAuthenticated: false });
				queryClient.clear();
			}
		}),
		{
			name: 'auth-storage'
		}
	)
);
